import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import veterinaryExamDeleteAction from './veterinaryExamDelete.action.json' with { type: 'json' }
import { veterinaryExamObject } from '../veterinaryExamObject'

const veterinaryExamDeleteDefinition = defineAction({
  ...veterinaryExamDeleteAction,

  input: z.object({
    id: veterinaryExamObject.shape.id,
  }),
  output: z.object({}),
})

export default veterinaryExamDeleteDefinition
